import { BasisType } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type {BasisTypeState} from "../basistypestate";


export const SET_BASISTYPE = "SET_BASISTYPE";
export class SetBasisType extends Action<typeof SET_BASISTYPE, BasisType> {
  readonly type = SET_BASISTYPE;
  protected state: BasisTypeState;

  constructor(state: BasisTypeState, data?: BasisType) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if (!this.isDoable()) return false;
    const basisType = this.data;
    if (!basisType) return true;
    const customerType = this.state.getData().customerType;
    const shouldThisCustomerTypeBeAllowedToChooseThisBasisType =
      customerType === "Company" && basisType?.name === "Massage" ? true : customerType === "Private" ? true : false;
    return shouldThisCustomerTypeBeAllowedToChooseThisBasisType;
  }

  public isDoable(): boolean {
    return true;
  }
}
